import { Component } from '../../../Models/Component';

export const ComponentsReducerName = 'components';

export interface IComponentsState {
  components: Component[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
